import links, { getLinkWithParams } from 'links'
import React, { useMemo } from 'react'

import Popup from 'compositions/map/MapContent/components/Popup/Popup'

import { Marker } from 'layers/publicTransport/components'

import busIcon from './images/station.png'


type StationMarkerProps = {
  className?: string
  title: string
  lat: number
  lon: number
  stationId: string
  isSmallIcon?: boolean
}

const StationMarker: React.FC<StationMarkerProps> = ({ className, title, stationId, lat, lon, isSmallIcon }) => {
  const position = useMemo(() => ([ lat, lon ]), [ lat, lon ])
  const iconSize = useMemo(() => (isSmallIcon ? [ 12, 12 ] : [ 24, 24 ]), [ isSmallIcon ])
  const iconAnchor = useMemo(() => (isSmallIcon ? [ 6, 6 ] : [ 12, 12 ]), [ isSmallIcon ])

  return (
    <Marker
      className={className}
      position={position}
      icon={busIcon}
      iconSize={iconSize}
      iconAnchor={iconAnchor}
      popupAnchor={[ 117, 0 ]}
    >
      <Popup
        data={{
          type: 'simpleCard',
          title,
          subTitle: 'Остановка',
          to: getLinkWithParams(links.transport.stations.details, { stationId }),
        }}
      />
    </Marker>
  )
}


export default StationMarker
